(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cimo-forjas-ui"]) return;
  try {
    

(() => {
  if (customElements.get('cimo-forjas-ui')) return;
  class CimoForjasUI extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const ready = () => {
        if (!this.isConnected || this.controller) return;
        if (!this.querySelector('dialog') || !this.querySelector('[data-cf-cart-template]')?.content.firstElementChild) return;
        this.readyObserver?.disconnect();
        this.initialize();
      };
      this.readyObserver = new MutationObserver(ready);
      this.readyObserver.observe(this, { childList: true, subtree: true });
      queueMicrotask(ready);
    }
    initialize() {
      this.controller = new AbortController();
      this.observers = [];
      this.frame = 0;
      this.previousFocus = null;
      this.panel = this.querySelector('dialog');
      const signal = this.controller.signal;
      document.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target.closest('[data-cf-open]') : null;
        if (!target || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!this.panel || typeof this.panel.showModal !== 'function') return;
        if (document.querySelector('dialog[open]') && !this.panel.open) return;
        event.preventDefault();
        this.previousFocus = target;
        this.panel.showModal();
        document.documentElement.classList.add('cf-panel-open');
      }, { signal });
      this.querySelector('[data-cf-close]')?.addEventListener('click', () => this.panel.close(), { signal });
      this.panel?.addEventListener('click', (event) => {
        if (event.target !== this.panel) return;
        const box = this.panel.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.panel.close();
      }, { signal });
      this.panel?.addEventListener('close', () => {
        document.documentElement?.classList.remove('cf-panel-open');
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }, { signal });
      document.addEventListener('DOMContentLoaded', () => this.observe(), { once: true, signal });
      document.addEventListener('change', () => this.schedule(), { signal });
      document.addEventListener('shopify:section:load', () => this.observe(), { signal });
      document.addEventListener('cart:updated', () => this.schedule(), { signal });
      window.addEventListener('pageshow', () => this.schedule(), { signal });
      this.observe();
    }
    disconnectedCallback() {
      this.readyObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.observers?.forEach((observer) => observer.disconnect());
      cancelAnimationFrame(this.frame);
      document.documentElement?.classList.remove('cf-panel-open');
      document.querySelectorAll('[data-cf-owned]').forEach((element) => element.remove());
    }
    observe() {
      this.observers.forEach((observer) => observer.disconnect());
      this.observers = [];
      [document.getElementById('MainContent'), document.querySelector('cart-drawer#minicart')].filter(Boolean).forEach((root) => {
        const observer = new MutationObserver((records) => {
          const external = records.some((record) => {
            const element = record.target instanceof Element ? record.target : record.target.parentElement;
            return !element?.closest('[data-cf-owned]');
          });
          if (external) this.schedule();
        });
        observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['samitaws-variant-id', 'value'] });
        this.observers.push(observer);
      });
      this.schedule();
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (!this.isConnected) return;
        this.renderProduct();
        this.renderCart();
        document.querySelectorAll('[data-cf-open]').forEach((link) => {
          if (link.getAttribute('aria-controls') === 'CimoForjasPanel') return;
          link.setAttribute('aria-controls', 'CimoForjasPanel');
          link.setAttribute('aria-haspopup', 'dialog');
        });
      });
    }
    renderProduct() {
      if (this.dataset.showProduct !== 'true' || !this.dataset.productId) return;
      document.querySelectorAll('.section-main-product .price-wrapper.main-price[id^="price-"]').forEach((price) => {
        const sectionId = price.id.slice(6);
        const form = document.getElementById(`product-form-${sectionId}`);
        const variantId = form?.querySelector('input[name="id"]')?.value;
        let context = price.nextElementSibling;
        if (!context?.hasAttribute('data-cf-product-context')) {
          context = this.querySelector('[data-cf-product-template]')?.content.firstElementChild?.cloneNode(true);
          if (!context) return;
          price.insertAdjacentElement('afterend', context);
        }
        if (this.dataset.member !== 'true') return;
        const actual = price.querySelector('[data-product-actual-price]');
        const confirmed = Boolean(variantId && Array.from(actual?.querySelectorAll('[samitaws-variant-id]') || []).some((node) => {
          return node.getAttribute('samitaws-variant-id') === String(variantId) &&
            node.getAttribute('samitaws-product-id') === this.dataset.productId &&
            node.querySelector('.samitaWS-customized-price') && node.querySelector('.samitaWS-customized-original-price');
        }));
        const applied = context.querySelector('[data-cf-confirmed]');
        const pending = context.querySelector('[data-cf-pending]');
        if (applied && applied.hidden === confirmed) applied.hidden = !confirmed;
        if (pending && pending.hidden !== confirmed) pending.hidden = confirmed;
      });
    }
    renderCart() {
      if (this.dataset.showCart !== 'true') return;
      const drawer = document.querySelector('cart-drawer#minicart');
      if (!drawer) return;
      const existing = drawer.querySelector('[data-cf-cart-context]');
      if (!drawer.querySelector('[data-cart-item]')) {
        existing?.remove();
        return;
      }
      if (existing) return;
      const totals = drawer.querySelector('.cart-total-box');
      const template = this.querySelector('[data-cf-cart-template]');
      if (!totals || !template) return;
      const context = template.content.firstElementChild.cloneNode(true);
      totals.insertAdjacentElement('beforebegin', context);
    }
  }
  customElements.define('cimo-forjas-ui', CimoForjasUI);
})();

  } catch(e) { console.error(e); }
})();
})();
